import React from "react";
import "./dashboardItem.css";
import DashboardAPIGateway from "../DevicesPage/DashboardComponents/DashboardApiGateway.tsx";
import DashboardEnvData from "./DashboardComponents/DashboardEnvData.tsx";
import DashboardDoorSensor from "../DevicesPage/DashboardComponents/DashboardDoorSensor.tsx";
import DashboardPushButton from "../DevicesPage/DashboardComponents/DashboardPushButton.tsx";

const DashboardItem = ({onComponentClick}) => {
    return (
        <div className="dashboardMainContainer" >
            <p className="devicesDashboardStoreName">Crown City</p>
            <div className="dashboardInnerContainer">
                <div className="box1" onClick = {()=> onComponentClick("API Gateway")}>
                    <DashboardAPIGateway  />
                </div>
                <div className="box2" onClick={()=> onComponentClick("Push Button")}>
                    <DashboardPushButton />
                </div>
                <div className="box3" onClick={()=> onComponentClick("Environment Data")}>
                    <DashboardEnvData />
                </div>
                <div className="box4" onClick={()=> onComponentClick("Door Sensor")}>
                    <DashboardDoorSensor />
                </div>
            </div>
        </div>
    )
}

export default DashboardItem;